import copyToClipboard from '@/shared/mixins/copyToClipboard';
import { getCurrentInstance } from 'vue';

// Using approach established by useShow.js
export default function() {
    const self = getCurrentInstance().proxy;

    return {
        copyTextToClipboard: copyToClipboard.methods.copyTextToClipboard.bind(self),
        copyUrlToClipboard: copyToClipboard.methods.copyUrlToClipboard.bind(self)
    };
}
